const test = "test";
const staging = "staging";
const production = "production";
const development = "development";

type envType =
  | typeof test
  | typeof staging
  | typeof production
  | typeof development;

const apiURL = process.env.NEXT_PUBLIC_API_HOST;
const environment = process.env.NEXT_PUBLIC_NODE_ENV as envType;
const authSecret = process.env.AUTH_SECRET;

const envs = {
  [test]: test,
  [staging]: staging,
  [production]: production,
  [development]: development,
};

const isTesting: boolean = envs.test === environment;
const isStaging: boolean = envs.staging === environment;
const isProduction: boolean = envs.production === environment;
const isDevelopment: boolean = envs.development === environment;

const isSSR = typeof window === "undefined";

const getEnv = (): string | undefined => {
  return environment && envs[environment];
};

const getHostURL = (): string => {
  if (isSSR) return "";

  return `${location.protocol}//${location.host}`;
};

export {
  apiURL,
  authSecret,
  isTesting,
  isStaging,
  isProduction,
  isDevelopment,
  isSSR,
  getEnv,
  getHostURL,
};
